/* global zE, LogRocket */
import { getQueryParameter } from '../../helpers/dataUrl';

module.exports = function () {
  const enabledOptions = getEnabledOptions();

  processConditionalHeaderOptions(enabledOptions);
  processConditionalTabs(enabledOptions);

  isCompanyNamespace('kw') && enableKwWebSpecificFeatures();
};

function isCompanyNamespace (domain) {
  const config = INKIVE.C.WHITE_LABEL_CONFIGURATION;
  return config.domain === domain || config.parent_domain === domain || config.parent_company === domain;
}

function getEnabledOptions () {
  const features = [];
  const isKw = isCompanyNamespace('kw');
  const isRedfin = isCompanyNamespace('redfin');
  const isRealEstate = ['real-estate', 'sir'].findIndex(isCompanyNamespace) > -1;

  (isRedfin || getQueryParameter('back_url'))
    ? features.push('feature--back-option')
    : features.push('-feature--back-option');

  isKw
    ? features.push('company--kw')
    : features.push('-company--kw');

  isRedfin
    ? features.push('company--redfin')
    : features.push('-company--redfin');

  isRealEstate && features.push('company--real-estate');

  INKIVE.C.SHOW_ANIMATION && features.push('feature--animation');
  INKIVE.C.SHOW_LAYOUT && features.push('feature--layout');
  INKIVE.C.SHOW_TEXT_OVERFLOW && features.push('feature--text-overflow');
  features.push(`book-type--${INKIVE.C.BOOK.book_type}`);

  if (INKIVE.C.REVIEW_MODE) {
    features.push('finish-later');
    features.push('submit-for-review');
  }

  return features;
}

function processConditionalHeaderOptions (enabledOptions) {
  const conditionalFeatureNodes = document.querySelectorAll('header [data-conditional]');
  processConditionalNodes(enabledOptions, conditionalFeatureNodes);
}

function processConditionalTabs (enabledOptions) {
  const conditionalFeatureNodes = document.querySelectorAll('#tool-panel [data-conditional]');
  processConditionalNodes(enabledOptions, conditionalFeatureNodes);
}

function processConditionalNodes (enabledOptions, nodes) {
  for (const node of nodes) {
    let shouldShow = false;
    const conditions = node.getAttribute('data-conditional').split();

    for (const condition of conditions) {
      if (enabledOptions.includes(condition)) {
        shouldShow = true;
        break;
      }
    }

    shouldShow
      ? node.removeAttribute('data-conditional')
      : node.parentElement.removeChild(node);
  }
}

function enableKwWebSpecificFeatures () {
  INKIVE.C.LOG_ROCKET && loadLogRocket();
  loadZendeskWidget();
}

async function loadLogRocket () {
  await getScript('https://cdn.lr-ingest.io/LogRocket.min.js');

  LogRocket.init(INKIVE.C.LOG_ROCKET, { release: INKIVE.C.VERSION });

  LogRocket.identify(INKIVE.C.USER.kw_uid || INKIVE.C.USER.id, {
    desygner_id: INKIVE.C.USER.id,
    name: Base64.decode(INKIVE.C.USER.nickname),
    email: Base64.decode(INKIVE.C.USER.email)
  });
}

async function loadZendeskWidget () {
  const colors = INKIVE.C.WHITE_LABEL_CONFIGURATION.colors;

  await (new Promise(resolve => {
    const script = document.createElement('script');
    script.id = 'ze-snippet';
    script.type = 'text/javascript';
    script.onload = resolve;
    script.src = 'https://static.zdassets.com/ekr/snippet.js?key=f87fa821-8bd7-4b6d-aa38-74d99520ed20';
    document.getElementsByTagName('head')[0].appendChild(script);
  }));

  window.zESettings = {
    webWidget: {
      position: { horizontal: 'left', vertical: 'bottom' },
      color: { theme: colors.highlight }
    }
  };

  zE(function () { zE.hide(); });
}

function getScript (url) {
  return new Promise(resolve => INKIVE.Helpers.getScript(url, resolve));
}
